/**
 * Testimonial Carousel Component
 * Simple carousel functionality for testimonials
 */
if (!window.customElements.get("testimonial-carousel")) {
  class TestimonialCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.items = [];
      this.autoplayInterval = null;
      this.cycleSpeed = 5000; // Default 5 seconds
    }

    connectedCallback() {
      this.items = Array.from(this.querySelectorAll(".testimonial-item"));

      // Get autoplay setting
      const autoplay = this.getAttribute("autoplay");
      if (autoplay) {
        this.cycleSpeed = parseInt(autoplay) * 1000 || 5000;
        this.startAutoplay();
      }

      // Handle swipe if enabled
      if (this.hasAttribute("allow-swipe")) {
        this.setupSwipe();
      }

      // Listen for navigation clicks
      this.setupNavigation();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    setupNavigation() {
      // Page dots navigation
      const pageDots = document.querySelectorAll(
        `.page-dots[aria-controls="${this.id}"] .tap-area`
      );
      pageDots.forEach((dot, index) => {
        dot.addEventListener("click", () => {
          this.goToSlide(index);
        });
      });

      // Thumbnail navigation
      const thumbnails = document.querySelectorAll(
        `.testimonial-list__thumbnail-scroller[aria-controls="${this.id}"] .testimonial-list__thumbnail`
      );
      thumbnails.forEach((thumb, index) => {
        thumb.addEventListener("click", () => {
          this.goToSlide(index);
        });
      });
    }

    setupSwipe() {
      let startX = 0;
      let startY = 0;
      let isDragging = false;

      this.addEventListener("touchstart", (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isDragging = true;
      });

      this.addEventListener("touchmove", (e) => {
        if (!isDragging) return;
        e.preventDefault();
      });

      this.addEventListener("touchend", (e) => {
        if (!isDragging) return;
        isDragging = false;

        const endX = e.changedTouches[0].clientX;
        const endY = e.changedTouches[0].clientY;
        const diffX = startX - endX;
        const diffY = startY - endY;

        // Only handle horizontal swipes
        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
          if (diffX > 0) {
            this.next();
          } else {
            this.previous();
          }
        }
      });
    }

    goToSlide(index) {
      if (index < 0 || index >= this.items.length) return;

      // Update items
      this.items.forEach((item, i) => {
        if (i === index) {
          item.classList.add("is-selected");
        } else {
          item.classList.remove("is-selected");
        }
      });

      // Update navigation
      this.updateNavigation(index);
      this.currentIndex = index;

      // Restart autoplay if enabled
      if (this.hasAttribute("autoplay")) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    next() {
      const nextIndex =
        this.currentIndex + 1 >= this.items.length ? 0 : this.currentIndex + 1;
      this.goToSlide(nextIndex);
    }

    previous() {
      const prevIndex =
        this.currentIndex - 1 < 0 ? this.items.length - 1 : this.currentIndex - 1;
      this.goToSlide(prevIndex);
    }

    updateNavigation(index) {
      // Dispatch carousel change event
      this.dispatchEvent(
        new CustomEvent("carousel:change", {
          detail: { index },
          bubbles: true,
        })
      );

      // Update page dots
      const pageDots = document.querySelectorAll(
        `.page-dots[aria-controls="${this.id}"] .tap-area`
      );
      pageDots.forEach((dot, i) => {
        dot.setAttribute("aria-current", i === index ? "true" : "false");
      });

      // Update thumbnails
      const thumbnails = document.querySelectorAll(
        `.testimonial-list__thumbnail-scroller[aria-controls="${this.id}"] .testimonial-list__thumbnail`
      );
      thumbnails.forEach((thumb, i) => {
        thumb.setAttribute("aria-current", i === index ? "true" : "false");
      });
    }

    select(index) {
      this.goToSlide(index);
    }

    startAutoplay() {
      this.stopAutoplay();
      this.autoplayInterval = setInterval(() => {
        this.next();
      }, this.cycleSpeed);
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }
  }

  window.customElements.define("testimonial-carousel", TestimonialCarousel);
}

